import { render } from "./Text.vue?vue&type=template&id=1ce4dcbc"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/Text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ce4dcbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ce4dcbc', __exports__)) {
    api.reload('1ce4dcbc', __exports__)
  }
  
  module.hot.accept("./Text.vue?vue&type=template&id=1ce4dcbc", () => {
    api.rerender('1ce4dcbc', render)
  })

}


export default __exports__